import { ServiceDto } from "@apiModels/ServiceDto.csharp";
import { SpecializationDto } from "@apiModels/SpecializationDto.csharp";
import { DoctorDto } from "@apiModels/DoctorDto.csharp";
import { useEffect, useState } from "react";
import { LocationDto } from "@apiModels/LocationDto.csharp";
import { ServiceGroupDto } from "@apiModels/ServiceGroupDto.csharp";
import _sortBy from "lodash.sortby";

export const useFilteredServices = (
  services: ServiceDto[],
  serviceGroups: ServiceGroupDto[],
  specialization: SpecializationDto,
  doctor: DoctorDto,
  location: LocationDto,
  selectedServiceGroup: ServiceGroupDto
) => {
  const [filteredItems, setFilteredItems] = useState<
    (ServiceGroupDto | ServiceDto)[]
  >([]);
  const [otherItems, setOtherItems] = useState<
    (ServiceGroupDto | ServiceDto)[]
  >([]);
  const [filteredGroupItems, setFilteredGroupItems] = useState<
    (ServiceGroupDto | ServiceDto)[]
  >([]);
  const [otherGroupItems, setOtherGroupItems] = useState<
    (ServiceGroupDto | ServiceDto)[]
  >([]);

  useEffect(() => {
    const servicesWithoutGroupAvailableForBooking = services.filter(
      (service) =>
        !service.serviceGroupId ||
        !serviceGroups.some((sg) => sg.id === service.serviceGroupId)
    );

    const servicesOfSelectedServiceGroup = selectedServiceGroup?.services
      ? [...selectedServiceGroup.services]
      : [];
    let filteredServices = [...servicesWithoutGroupAvailableForBooking];
    let filteredServiceGroups = [...serviceGroups];
    let filteredServicesOfGroup = [...servicesOfSelectedServiceGroup];
    if (specialization.id) {
      filteredServices = filteredServices.filter(
        (service) => service.specializationId == specialization.id
      );
      filteredServiceGroups = filteredServiceGroups.filter(
        (service) => service.specializationId == specialization.id
      );
    }

    if (doctor.id && doctor.id != "-1") {
      filteredServices = filteredServices.filter(
        (service) =>
          doctor.services.includes(service.id) &&
          !service.disableDoctorPageListing
      );
      filteredServiceGroups = filteredServiceGroups.filter(
        (service) =>
          doctor.services.includes(service.id) ||
          service.services.some((s) => doctor.services.includes(s.id))
      );
      filteredServicesOfGroup = filteredServicesOfGroup.filter((service) =>
        doctor.services.includes(service.id)
      );
    }

    if (location.id && location.id != "-1") {
      filteredServices = filteredServices.filter(
        (service) =>
          service.centerBookingOptions.filter(
            (center) =>
              center.centerId == location.id ||
              (location.centers && location.centers.includes(center.centerId))
          ).length > 0
      );
      filteredServiceGroups = filteredServiceGroups.filter((serviceGroup) =>
        serviceGroup.services.some(
          (service) =>
            service.centerBookingOptions.filter(
              (center) =>
                center.centerId == location.id ||
                (location.centers && location.centers.includes(center.centerId))
            ).length > 0
        )
      );
      filteredServicesOfGroup = filteredServicesOfGroup.filter(
        (service) =>
          service.centerBookingOptions.filter(
            (center) =>
              center.centerId == location.id ||
              (location.centers && location.centers.includes(center.centerId))
          ).length > 0
      );
    }

    if (specialization.id) {
      const unavailableServices = servicesWithoutGroupAvailableForBooking
        .filter((service) => service.specializationId == specialization.id)
        .filter(
          (service) =>
            !doctor.id || doctor.id == "-1" || !service.disableDoctorPageListing
        )
        .filter((s) => filteredServices.some((fs) => fs.id == s.id) == false);
      const unavailableServiceGroups = serviceGroups
        .filter(
          (serviceGroup) => serviceGroup.specializationId == specialization.id
        )
        .filter(
          (s) => filteredServiceGroups.some((fs) => fs.id == s.id) == false
        );

      setOtherItems(
        _sortBy(
          [...unavailableServices, ...unavailableServiceGroups],
          ["sortIndex"]
        )
      );

      const unavailableServicesOfGroup = servicesOfSelectedServiceGroup.filter(
        (service) => filteredServicesOfGroup.every((fs) => fs.id !== service.id)
      );

      setOtherGroupItems(unavailableServicesOfGroup);
    }

    setFilteredItems(
      _sortBy([...filteredServices, ...filteredServiceGroups], ["sortIndex"])
    );

    setFilteredGroupItems(filteredServicesOfGroup);
  }, [doctor, specialization, location, selectedServiceGroup?.id]);

  return {
    filteredServices: filteredItems,
    unavailableServices: otherItems,
    filteredGroupServices: filteredGroupItems,
    unavailableGroupServices: otherGroupItems,
  };
};
